import type { TItem, TItemType, TResolvedItemNames } from '@modules/items';
import type { TSearchBlocksCondition, TSearchTemplatesCondition } from './constants';

/** A single search result, augmenting a normal item with a snippet of matching text */
export type TSearchItem = TItem & {
  snippet: string;
};

/** Payload returned by GET /search */
export type TSearchResponse = {
  total: number;
  items: TSearchItem[];
  resolvedNames: TResolvedItemNames;
};

/** Body (or params) to send when querying search */
export type TSearchQuery = {
  query: string;
  page: number;
  pageSize: number;
  folderId?: string;
  itemTypes?: TItemType[];
  blocksCondition?: TSearchBlocksCondition;
  templatesCondition?: TSearchTemplatesCondition;
};

export const isTSearchItem = (item: TItem | TSearchItem): item is TSearchItem => Boolean((item as TSearchItem).snippet);
